export const useProductsStore = defineStore('products', {
  state: () => {
    return {
      prices: null,
      subscriptionConfigs: null,
      billingCurrencies: null,
    };
  },

  actions: {
    async fetchPrices() {
      // NOTE: "in." is a reserved workspace domain name for universal workspace
      const response = await useApi.get(`${useRequestURL().protocol}//in.${useRuntimeConfig().public.interfaceDomain}/api/public/products/prices`).catch((error) => {
        // Network unreachable (in.* subdomain unresolvable from localhost dev,
        // VPN drop, etc.) shouldn't fire a toast every refresh. Only surface
        // real server errors where the API actually responded.
        if (error?.response?.status) useToast.error(useT('bcd270'));
      });

      this.prices = response;

      return response;
    },

    async fetchSubscriptionConfigs() {
      // NOTE: "in." is a reserved workspace domain name for universal workspace
      const response = await useApi.get(`${useRequestURL().protocol}//in.${useRuntimeConfig().public.interfaceDomain}/api/public/products/subscription-configs`).catch((error) => {
        if (error?.response?.status) useToast.error(useT('bcd270'));
      });

      this.subscriptionConfigs = response;

      return response;
    },

    // What each billing currency asks of a new workspace (an IČO for CZK, a VAT ID for EUR).
    // Interface owns these rules; the console reads them instead of keeping its own copy.
    async fetchBillingCurrencies() {
      // NOTE: "in." is a reserved workspace domain name for universal workspace
      const response = await useApi.get(`${useRequestURL().protocol}//in.${useRuntimeConfig().public.interfaceDomain}/api/public/products/billing-currencies`).catch((error) => {
        if (error?.response?.status) {
          useToast.error(useT('bcd270'));
        }
      });

      this.billingCurrencies = response || null;

      return response;
    },
  },

  getters: {
    // The fields a workspace in this currency must carry; none while the rules are not loaded,
    // and interface still refuses a workspace that lacks one.
    getRequiredWorkspaceFields(state) {
      return (currency) => state.billingCurrencies?.[currency]?.requiredWorkspaceFields || [];
    },

    getProductConfig(state) {
      return (product) => {
        if (product?.category === 'planSubscription') {
          return state.subscriptionConfigs[product?.key];
        }

        if (product?.category === 'planSingleUse') {
          return {
            tier: product?.data?.tier,
            maxCapacity: product?.data?.maxCapacity,
          };
        }

        if (product?.category === 'addon') {
          return {
            name: product?.data?.name,
            billingPeriod: 'monthly', // NOTE: create a addons configs file is there will be more then 3 addons
          };
        }

        return false;
      };
    },
  },
});
